import React, { useState } from 'react'
import { Link } from "react-router-dom"
import logo from "../images/logo.png"
import Header from './Header'

function Navbar() {

    const [nav, setnav] = useState(false)

    // const BackgroundChange = () => {
    //     if (window.scrollY <= 50) {
    //         setnav(true)
    //     } else {
    //         setnav(false)
    //     }
    // }
    // window.addEventListener("scroll", BackgroundChange)


    return (
        <>
     
            {/* <nav className={nav ? "nav active" : "nav"}> */}
            <nav>
                <Link to="/" className="logo">
                    <img src={logo} alt="" />
                </Link>
                <input className="menu-btn" id="menu-btn" type="checkboxF"></input>
                <label className="menu-icon" for="menu-btn">
                    <span className="nav-icon"></span>
                </label>
                <ul className="menu">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/Aboutus">About</Link></li>
                    <li><Link to="/Gallery2">Portfolio</Link></li>
                    <li><Link to="Contact">Contact</Link></li>

                </ul>

            </nav>

        </>
    )
}

export default Navbar
